import React from 'react';
import PropTypes from 'prop-types';

import { columnConfig } from '@app/dev/terminal/containers/bethistory/components/withdrawalHistory/config';
import EmptyState from '@app/dev/terminal/containers/bethistory/components/emptyState';
import WithdrawalService from '@app/dev/terminal/components/withdrawal/services';
import SmartTable from '@common/components/smartTable';
import { useDataFetch } from '@common/hooks/dataFetch';

const WithdrawalHistory = ({ start, end }) => {
  const list = useDataFetch(
    () => (start && end)
      && WithdrawalService.getHistory(Date.parse(start) / 1000, Date.parse(end) / 1000),
    [start, end],
  );
  const historyData = list[0] || [];

  return (
    !historyData.length ? <EmptyState />
      : (<SmartTable data={historyData} columnConfig={columnConfig} />)
  );
};

export default WithdrawalHistory;

WithdrawalHistory.propTypes = {
  start: PropTypes.object,
  end: PropTypes.object,
};
